import {DataCell, ModuleTable} from "../../../Utils/Lists/CollapsibleList";
import TableRow from "@material-ui/core/TableRow";
import {AutoCompleteUnControlled} from "../../../Utils/FormInputs/AutoCompleteInput";
import Textarea from "../../../Utils/FormInputs/Textarea";
import InputGroup from "react-bootstrap/InputGroup";
import TextField from "../../../Utils/FormInputs/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import {StyledCell, StyledRemoveIcon} from "../../../DoctorsModule/doctorStyles";
import React, {useState} from "react";
import {BlockNavigationComponent} from "../../../Utils/ReusableComponents/BlockNavigationComponent";
import {history} from "../../../../Helpers/history";
import {ConfirmationDialog} from "../../../Utils/ReusableComponents/ConfirmationDialog";
import {v4 as uuidv4} from "uuid";
import {titleCase} from "../../../Users/addUser";
import axios from "axios";
import {config} from "../../../../Helpers/env";
import {errorMessages, logoutErrorMessage} from "../../../../Helpers/ErrorMessages";

const headData = [{item:'Test Name',toolTip:'Make imaging request here', isRequired:true},
    {item:'Purpose',toolTip:'Enter purpose of the investigation', isRequired:true},
    {item:'Cost', isRequired:false}, {item:'Action', isRequired:false}]


const AddGynRadiologyRequest = ({actions, visit_id,isSubmitted, setIsSubmitted, setOpenDialog,
                                    isBlocking, setIsBlocking,isBlockDialog, setIsBlockDialog}) =>{

    const user = JSON.parse(sessionStorage.getItem('user'));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const user_roles_id = !_token.user_roles_id ? "" : _token.user_roles_id;

    const initialState = [{
        hospital_scan_id: '', scan_name: '', scan_type: '', indication: '', service_id: '',
        qty: 1, showScan: false, purpose: '', isError: false, cost: 0,
        currency_id:'', currency_symbol:'',  uuid: uuidv4(),
    }]
    const [submitted, setSubmitted] = useState(false);
    const [scanTests, setScanTests] = useState([]);
    const [scans, setScans] = useState(initialState);
    const [openConfirmation, setOpenConfirmation] = useState(false)
    const [scan_id, setScanId] = useState('')

    const getScanTests = (eventTxt, idx) => {
        const arr = scans.map((item, index) => {
            if (index=== idx) {
                const formData = new FormData();
                formData.append('hospital_scan_name', titleCase(eventTxt));
                if (eventTxt !== '') {
                    axios.post(`${config.smsUrl}/cdoctor/autocompletesearch_hospt_scans`, formData).then(res => {
                        const resp = res.data;
                        const data = !resp ? [] : resp;
                        if (data.length > 0) {
                            const arr = data.map(item=>({...item, value:item.hospital_scan_id, label:item.hospital_scan_name}))
                            setScanTests(arr);
                        } else {
                            setScanTests([{hospital_scan_id: '', hospital_scan_name: 'No Scan tests found'}])
                        }
                    }).catch(error => {
                        logoutErrorMessage(error, null, actions)
                    });
                    return {...item, scan_name: eventTxt, showScan: true, isError: false}
                }
                return {...item, scan_name: eventTxt, showScan: false, isError: false}
            }
            return item
        })
        setScans(arr)
        setIsBlocking(true)
    };

    const retrieveScanDetails = (event, idx) => {
        let arr = scans.map((item, index)=>{
            if(index === idx){
                return {...item, scan_name:event.innerText, hospital_scan_id:event.value,
                    isError:false, showScan:false}
            }
            return item
        })
        const formData = new FormData();
        formData.append('hospital_scan_id', event.value);
        if (event.value) {
            axios.post(`${config.smsUrl}/cdoctor/getscandetails_by_scan_id`, formData).then(res => {
                const data = res.data;
                const details = !data ? {} : data;
                axios.post(`${config.smsUrl}/cbilling/item_cost`, {visit_id: +visit_id, item_id:data.service_id, item_type:'service'}).then(res => {
                    const resObj = res.data;
                    const dataObj = !resObj.data ? {} : resObj.data;
                    arr = arr.map((item, index)=>{
                        if(index === idx){
                            return {...item, scan_type:details.scan_type_name, service_id: details.service_id,cost:  dataObj.cost ?? 0,
                                currency: dataObj.currency_id, currency_symbol: dataObj.currency, ...dataObj }
                        }
                        return item
                    })
                    setScans(arr);
                    if(dataObj.is_provider === 1 && dataObj.is_provided === 0){
                        setScanId(details.hospital_scan_id)
                        setOpenConfirmation(true)
                    }
                }).catch(error => {
                    errorMessages(error, null, actions)
                });
            }).catch(error => {
                errorMessages(error, null, actions)
            });
        }
        setIsBlocking(true)
    }

    const addItemsToReceipt = () =>{
        setOpenConfirmation(false)
    }

    const handleCloseConfirmation = () =>{
        const arr = scans.filter(item=>item.hospital_scan_id !== scan_id)
        setScans(arr)
        setOpenConfirmation(false)
    }

    const handleCancelConfirmation = () =>{
        setOpenConfirmation(false)
    }

    const handleChangePurpose = (e, index) => {
        const {value} = e.target
        const arr = scans.map((item, idx) => {
            if (idx === index) {
                return {...item, purpose: value, isEdited: !!item.scan_requests_detail_id}
            }
            return item
        })
        setScans(arr)
        setIsBlocking(true)
    }

    const handleAddRow = () => {
        setScans([...scans, ...initialState])
        setIsSubmitted('idle')
    };

    const removeRow = (item_uuid) => {
        const arr = scans.filter((e) => e.uuid !== item_uuid)
        setScans(arr);
    };

    const handleSubmitScanRequest = (event) => {
        event.preventDefault();
        const arr = scans.every(item => item.hospital_scan_id)
        setSubmitted(true);
        const params = {
            visit_id:+visit_id, user_roles_id,
            scan_state:1,
            result_type: 3, bill_type: 2, bill_details: scans.filter(scan => scan.hospital_scan_id && scan.service_id &&
                !scan.scan_requests_detail_id).map(item => ({
                hospital_scan_id: item.hospital_scan_id,
                service_id: item.service_id,
                purpose: item.purpose,
                quantity: 1, rate: item.cost,
                is_provided: item.is_provided,
                is_provider: item.is_provider,
                currency_id:item.currency_id
            }))
        }
        setIsBlocking(false)
        if (arr) {
            setIsSubmitted('pending')
            axios.post(`${config.smsUrl}/cdoctor/save_scan_request`, {...params}).then(() => {
                actions.snackbarActions.snackSuccess('Requested submitted successfully');
                setIsSubmitted('resolved');
                setSubmitted(false);
                setScans(initialState)
                setOpenDialog(false)
            }).catch(err => {
                errorMessages(err, null, actions)
                setIsSubmitted('rejected');
            })
        }
    };


    const handleResetForm = () =>{
        setIsBlockDialog(false)
        setIsBlocking(false)
        setOpenDialog(false);
        setSubmitted(false);
        const arr = scans.map(item=>({
            ...item,   hospital_scan_id: '', scan_name: '', scan_type: '', indication: '', service_id: '',
            qty: 1, showScan: false, purpose: '', isError: false, cost: 0,
            currency_id:'', currency_symbol:'',  uuid: uuidv4(),

        }))
        setScans(arr)
    }

    const isPending = isSubmitted === 'pending'

    const all_scans = scanTests ? scanTests :[]

    return (
        <div>
            <BlockNavigationComponent
                when={isBlocking}
                shouldBlockNavigation={()=>{
                    return isBlocking;
                }}
                navigate={path=>history.push(path)}
                dialogClose={isBlockDialog}
                setIsBlockDialog={setIsBlockDialog}
                clearForm={handleResetForm}
            />

            <ConfirmationDialog open={openConfirmation} handleClose={handleCancelConfirmation} title='Make cash payment'
                                confirmItems={addItemsToReceipt} removeItems={handleCloseConfirmation} service='scan'/>

            <form onSubmit={handleSubmitScanRequest}>
                <ModuleTable headData={headData}>
                    {scans.map((scan, index) => (
                        <TableRow
                            key={scan.uuid}
                        >
                            <DataCell variant='200'>
                                <AutoCompleteUnControlled options={all_scans} submitted={submitted} idx={index} handleChange={getScanTests} label_text="hospital_scan_name"
                                                          medicine_value={{label:scan.scan_name, value: scan.hospital_scan_id}} id="scan_name" value_text="hospital_scan_id"
                                                          valid_error_check={scan.isError} errorMsg_Valid="Please enter a valid name" testId={`scan_name-${index}`}
                                                          handleProductData={retrieveScanDetails} placeholder="Type Test name" errorMsg="Test name is required<"/>
                            </DataCell>
                            <DataCell variant='150'>
                                <Textarea as="textarea" id={`purpose-${index}`}
                                          value={scan.purpose}
                                          onChange={e => handleChangePurpose(e, index)}
                                          name="purpose"/>
                            </DataCell>
                            <DataCell variant='150'>
                                <InputGroup>
                                    <InputGroup.Text style={{borderRadius:'0.7rem 0 0 0.7rem'}} id="basic-addon1">{scan.currency_symbol}</InputGroup.Text>
                                    <TextField  type="number" value={scan.cost} style={{pointerEvents:'none'}}/>
                                </InputGroup>
                            </DataCell>
                            <DataCell>
                                <Tooltip title='Remove'>
                                    <IconButton type='button' onClick={() => removeRow(scan.uuid)}>
                                        <StyledRemoveIcon/>
                                    </IconButton>
                                </Tooltip>
                            </DataCell>
                        </TableRow>
                    ))}
                    <TableRow>
                        <StyledCell colSpan={headData.length}>
                            <button type="button" onClick={handleAddRow} className="btn btn-sm sms-gray-btn"
                                    id="add-row">Add another line
                            </button>
                        </StyledCell>
                    </TableRow>
                </ModuleTable>
                <button type='submit' className='btn sms-btn btn-sm' disabled={isPending}>
                    {isPending ? 'Saving...' : 'Save  Request'}</button>
            </form>

        </div>

    )
}

export {AddGynRadiologyRequest}